import { useQuery } from "@tanstack/react-query";
import { toast } from "sonner";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { useApi, errMsg, fmtDate } from "@/lib/api";

export function UsersTab() {
  const api = useApi();
  const q = useQuery({ queryKey: ["admin-users"], queryFn: () => api("get", "/users"), staleTime: 0 });
  const change = async (u, role) => {
    try { await api("patch", `/users/${u.user_id}/role`, { role }); toast.success("Role updated"); q.refetch(); }
    catch (e) { toast.error(errMsg(e)); }
  };
  return (
    <div className="bg-white border border-slate-200 rounded-sm overflow-x-auto">
      <Table>
        <TableHeader><TableRow><TableHead>Name</TableHead><TableHead>Email</TableHead><TableHead>Joined</TableHead><TableHead>Role</TableHead></TableRow></TableHeader>
        <TableBody>
          {(q.data?.users || []).map((u) => (
            <TableRow key={u.user_id} data-testid={`user-row-${u.user_id}`}>
              <TableCell>{u.name || "-"}</TableCell>
              <TableCell className="text-sm">{u.email || "-"}</TableCell>
              <TableCell className="text-sm text-slate-500">{fmtDate(u.created_at)}</TableCell>
              <TableCell>
                <Select value={u.role} onValueChange={(v) => change(u, v)}>
                  <SelectTrigger className="w-36" data-testid={`user-role-select-${u.user_id}`}><SelectValue /></SelectTrigger>
                  <SelectContent>{(q.data?.roles || []).map((r) => <SelectItem key={r} value={r} className="capitalize">{r}</SelectItem>)}</SelectContent>
                </Select>
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </div>
  );
}
